/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExtraTypeResource } from './extraTypeResource';


export interface ExtraResource { 
    currency: ExtraResource.CurrencyEnum;
    extraFee: ExtraTypeResource;
    deduction: ExtraTypeResource;
    total: number;
}
export namespace ExtraResource {
    export type CurrencyEnum = 'Kč' | 'Eur';
    export const CurrencyEnum = {
        K: 'Kč' as CurrencyEnum,
        Eur: 'Eur' as CurrencyEnum
    };
}


